import { Component, OnInit, Input } from "@angular/core"
import { Store, Action } from "@ngrx/store"
import { Actions } from "@ngrx/effects"
import { AppState } from "@store/app-state"
import { ModalService } from "@services/modal"
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer"
import { Campus } from "@models/campus"
import { Course } from "@models/course"
import { Day } from "@models/day"
import { MatrixClassesStore } from "@store/matrix-classes"
import { ConstantsStore } from "@store/constants"
import { Observable } from "rxjs/Observable"
import { ConstData, ConstantsHelpers } from "@constants/helpers"
import {
  CREATE_CLASS,
  ADD_CLASS,
  CREATE_CLASS_FAILURE,
  UPDATE_CLASS,
  REPLACE_CLASS
} from "@reducers/matrix-class";
import { MatrixClassEffects } from "@reducers/effects/matrix-class"
import { Topic } from "@models/topic"
import { Term } from "@models/term"
import { MatrixClass } from "@models/matrix-class"
import { Contact } from "@models/contact"
import { Constants } from "@models/constants"

@Component({
  selector: 'set-class-form',
  templateUrl: './set-class-form.pug',
})
export class SetClassFormComponent implements OnInit {

  public matrixClassesStore: Observable<MatrixClassesStore>
  public constantsStore: Observable<ConstantsStore>
  public constants: Constants

  public matrixClass: MatrixClass
  public courseForTopics: Course

  public courseSearchStr: string
  public courseCompleter: CompleterData
  public courses: Course[]

  public teacherSearchStr: string = ""
  public teacherCompleter: CompleterData
  public teachers: Contact[]

  private originalHolidayWeekValue: number = 1

  constructor(
    public store: Store<AppState>,
    public modalService: ModalService,
    public completerService: CompleterService,
    public constantsHelpers: ConstantsHelpers,
    public matrixClassesEffects: MatrixClassEffects,
    private actions: Actions,
  ) {}

  ngOnInit() {
    this.matrixClassesStore = this.store.select("matrixClassesReducer")
    this.constantsStore = this.store.select("constantsReducer")

    Observable.merge(this.matrixClassesStore,
      this.constantsStore).subscribe((s: MatrixClassesStore | ConstantsStore) => {
        if (s instanceof MatrixClassesStore) {
          this.teachers                 = s.teachers
          this.matrixClass              = s.editableClass
          this.originalHolidayWeekValue = s.editableClass.holidayWeek
        }
        if (s instanceof ConstantsStore) {
          this.constants    = s.constants
          this.courses      = s.constants.courses
          this.createCourseCompleter()
        }
      })
  }

  createCourseCompleter() {
    this.courseCompleter = 
      this.completerService.local(this.courses, "humanised, code, name", "humanised")

    this.teacherCompleter =
      this.completerService.local(this.teachers, "fullName", "fullName")
  }

  setDefaultTopicIdForCourse(matrixClass: MatrixClass) {
    const term: Term = this.constants.terms.find((t: Term) => {
      return t.id === matrixClass.termId
    })
    const course: Course = this.courses.find((c: Course) => {
      return c.id === matrixClass.courseId
    })
    this.matrixClass.topicId = course.topics[term.number - 1].id
  }

  clickedIsTwoWeeksToggle(e: MouseEvent) {
    const isChecked = (e.target as any).checked

    this.matrixClass.holidayWeek = isChecked ?
      0 : this.originalHolidayWeekValue
  }

  clickedIsOpenToggle(e: MouseEvent) {
    this.matrixClass.open = !this.matrixClass.open
  }

  clickedIsTopicTestToggle(e: MouseEvent) {
    this.matrixClass.topicTest = !this.matrixClass.topicTest
  }

  clickedSubmitForm(e: MouseEvent) {
    e.preventDefault()

    if (this.matrixClass.id) {
      this.store.dispatch({ type: UPDATE_CLASS, payload: this.matrixClass })

    }
    else {
      this.store.dispatch({ type: CREATE_CLASS, payload: this.matrixClass })
    }

    this.actions
      .ofType(ADD_CLASS, REPLACE_CLASS)
      .take(1)
      .subscribe(() => this.modalService.closeModal())
  }

  selectedCourse(e: CompleterItem) {
    if (e && e.originalObject) {
      const course: Course = e.originalObject as Course
      this.courseForTopics = course
      this.matrixClass.courseId = course.id
      this.setDefaultTopicIdForCourse(this.matrixClass)
    }
  }

  selectedTeacher(e: CompleterItem) {
    if (e && e.originalObject) {
      const teacher: Contact = e.originalObject as Contact
      this.matrixClass.contactId = teacher.id
    }
  }

  selectedTopic(e: MouseEvent, topic: Topic) {
    this.matrixClass.topicId = topic.id
  }

  isHolidayTerm(): boolean {
    return this.matrixClass.term.isHoliday
  }

  getTermName() {
    return this.constants.terms.find((t: Term) => {
      return t.id === this.matrixClass.termId
    }).name
  }

  getDayNameOrHolidayWeek(): string {
    let result

    if (!this.matrixClass.term.isHoliday) {
      result = this.constants.days.find((d: Day) =>  {
        return d.id === this.matrixClass.dayId
      }).name
    }
    else {
      result = this.matrixClass.holidayWeek == 0 ?
        "Both weeks" : `Week ${this.matrixClass.holidayWeek}`
    }

    return result
  }

  getCampusTitle() {
    return this.constants.campuses.find((c: Campus) =>  {
      return c.id === this.matrixClass.campusId
    }).name
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/set-class-form.ts